module.exports = __webpack_public_path__ + "static/media/Bubbles.d88306aa.svg";